import { QueryClient } from "@tanstack/react-query";
import { Keys } from "../../common-interfaces/quiries-keys/keysValues";
import { IGetCart } from "./interfaces/cart-interfaces";

// Prefix match: `getKey()` reads cookies during render, so the key a component
// mounted under can differ from the one computed here (no currency_code cookie on
// a first visit). Exact-key writes landed on a key nothing was subscribed to.
// The invalidate is needed because the query is staleTime: Infinity — branch can
// change without a reload, so other variants must refetch on next mount rather
// than trust a cart fetched under this branch. refetchType "none" = mark only.
export const updateGetCartQueryData = (
  queryClient: QueryClient,
  data: IGetCart | any,
) => {
  queryClient.setQueriesData([Keys.get_cart], data);
  queryClient.invalidateQueries({
    queryKey: [Keys.get_cart],
    refetchType: "none",
  });
};
